export default "__VITE_ASSET__BeaoIUMW__"